import { isKim } from '@src/utils/user-agent';
import { KIM_EVENT } from './eventChannel';
import { GlobalEventEmitter } from './globalEventListner';

// 与桌面端通信的方法
export const sendKimEvent = (
  type: KIM_EVENT,
  options?: any,
  callback?: (result: any) => void,
  jumpVersionControl?: boolean,
) => {
  if (
    !isKim ||
    !window.KIM ||
    (Number(window.KIM?.kimVersion?.split('-')[1]) > 59640 &&
      !jumpVersionControl)
  ) {
    GlobalEventEmitter.emit(type, options);
    return;
  }
  if (callback && callback instanceof Function) {
    if (typeof window.KIM.sendWithCallback !== 'function') return;
    window.KIM.sendWithCallback(type, options, callback);
  } else {
    if (typeof window.KIM.send !== 'function') return;
    window.KIM.send(type, options);
  }
};

export const addListenerFromKim = (
  type: string,
  callback: (result: any) => void,
) => {
  if (!isKim || !window.KIM) return;
  if (typeof window.KIM.addListenerFromKim !== 'function') return;
  window.KIM.addListenerFromKim(type, callback);
};

export const openFeedbackGroup = () => {
  openSchemaUrl(`kim://thread?id=6707037163754771&type=4`);
};

export const openSchemaUrl = (url: string) => {
  if (window.KIM) {
    window.KIM?.openUrlWithDefaultBrowser(url);
  } else if (window.__kim_OpenApp_Bridge__) {
    // @ts-ignore
    window.__kim_OpenApp_Bridge__.invoke('open', {url})
  } else {
    window.open(url, '_blank');
  }
};

/**
 * 打开下载链接，始终使用 window.open 触发浏览器下载。
 * 不经过 openUrlWithDefaultBrowser，避免 webview 内直接打开磁盘/用系统默认应用打开文件。
 */
export const openDownloadUrl = (url: string) => {
  window.open(url, '_blank');
};
